var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnchorVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 160,
    viewBox: "0 0 379 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1 103.457C1 103.457 41.5 158.328 101.51 158.329C252.5 158.331 264.5 -14.5017 345 19.001",
    stroke: "#23286B",
    strokeWidth: 2,
    strokeDasharray: "10 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.216 24.8833C370.76 25.4276 370.511 26.357 369.767 26.5563L342.118 33.9649C341.212 34.2076 340.5 33.1823 341.045 32.4187L348.411 22.0814C348.809 21.5228 349.004 20.8446 348.963 20.1599L348.061 5.20134C348.006 4.28278 349.116 3.78338 349.766 4.43407L370.216 24.8833Z",
    stroke: "#23286B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.058,
    y1: 21.2604,
    x2: 369.74,
    y2: 25.0362,
    stroke: "#23286B",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorVector);
export default __webpack_public_path__ + "static/media/anchor-vector.9eb8760455a32767cb4eec8db13735b5.svg";
export { ForwardRef as ReactComponent };